import { memo, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
    Heading,
    VStack,
    Filtration,
    HStack,
    Text,
    Button,
    CloseIcon,
} from '@library';
import getAlphabetList from '../util/getAlphabetList';
import styles from './BrandFilters.module.scss';

const BrandFilters = ({
    query,
    chosenLetter,
    availableLetters,
    onChangeQuery,
    onChangeLetter,
    totalBrands,
}: {
    query: string;
    chosenLetter: string;
    availableLetters: string[];
    onChangeQuery(query: string): void;
    onChangeLetter(letter: string): void;
    totalBrands: number;
}) => {
    const intl = useIntl();

    const alphabetList = useMemo(
        () => getAlphabetList(availableLetters),
        [availableLetters]
    );

    return (
        <div className={styles.container}>
            <VStack gap="small">
                <HStack gap="mini" align="baseline">
                    <Heading h3 medium>
                        <FormattedMessage id="our brands" />
                    </Heading>

                    <Text>
                        {totalBrands} <FormattedMessage id="brands" />
                    </Text>
                </HStack>
                <HStack gap="mini" align="center">
                    <Filtration
                        emptyValue={{
                            search: '',
                        }}
                        filterValue={{
                            search: query,
                        }}
                        filters={[
                            {
                                field: 'search',
                                type: 'search',
                                placeholder: intl.formatMessage({
                                    id: 'find brand',
                                }),
                            },
                        ]}
                        onChangeFilters={filter => {
                            onChangeQuery(filter.search);
                        }}
                    />
                    <div className={styles.alphabetList}>
                        {alphabetList.map(letterOption => {
                            return (
                                <Button
                                    rounded
                                    key={letterOption.letter}
                                    onClick={() => {
                                        onChangeLetter(letterOption.letter);
                                    }}
                                    theme={styles.theme}
                                    secondary={
                                        chosenLetter === letterOption.letter
                                    }
                                    mini
                                >
                                    <Text uppercase truncate>
                                        {letterOption.letter}
                                    </Text>
                                </Button>
                            );
                        })}
                    </div>
                </HStack>

                {chosenLetter && (
                    <HStack align="center" gap="mini" wrap>
                        <Text>
                            <FormattedMessage id="Common Filter By" />:
                        </Text>

                        <Button
                            outline
                            rounded
                            mini
                            onClick={() => onChangeLetter('')}
                            data-test-class="filtration-clear"
                        >
                            <HStack align="center" gap="mini">
                                <Text secondary lineHeightAsFontSize>
                                    A-Z: {chosenLetter.toUpperCase()}
                                </Text>
                                <CloseIcon mini />
                            </HStack>
                        </Button>
                    </HStack>
                )}
            </VStack>
        </div>
    );
};

export default memo(BrandFilters);
